/* tslint:disable */
/* eslint-disable */
export enum WorkCategoryNameEnum {
  AktiverLead = 'Aktiver_Lead',
  Kunden = 'Kunden',
  Lieferanten = 'Lieferanten',
  Kontakte = 'Kontakte',
  Passiverlead = 'Passiverlead',
  Hersteller = 'Hersteller',
  Archiv = 'Archiv',
  Leads = 'Leads',
  Firmen = 'Firmen',
  Offen = 'Offen',
  ElektrikerLektriker = 'ElektrikerLEKTRIKER'
}
